import { DsdFileStatus } from "@/types/dsd";
import queries from "@/queries";
import { useQuery } from "@tanstack/react-query";

/** 워크북의 XBRL 분석이 끝났는지 여부. 롤포워드/오토태깅처럼 분석 완료를 전제로 하는 기능의 활성화 조건으로 사용. */
export function useIsWorkbookAnalyzed(workbookId: string | undefined) {
  const { data: dsdList } = useQuery({
    ...queries.dsd(),
    enabled: !!workbookId,
  });

  return (
    dsdList?.find((workbook) => workbook.id === workbookId)?.status ===
    DsdFileStatus.XBRL_ANALYZED
  );
}
